import { Component, OnInit } from '@angular/core';

declare var RDStationForms: any;

@Component({
  selector: 'app-parcerias',
  templateUrl: './parcerias.component.html',
  styleUrls: ['./parcerias.component.css']
})
export class ParceriasComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    new RDStationForms('aditt-parcerias-f04cef8312455fdb0a5d', 'UA-2727336-2').createForm();
  }

}
